"use client"

import { Disc } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DiscIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DiscIcon = component(Icon)({ as: Disc })
